// extracted by mini-css-extract-plugin
module.exports = {"userSelect_none":"_025a50318d--userSelect_none--3BRsJ","userSelect_auto":"_025a50318d--userSelect_auto--1oknE","userSelect_all":"_025a50318d--userSelect_all--q-GhC"};